module.exports = __webpack_public_path__ + "img/1538160620.94356c73.jpg";